module.exports = __webpack_public_path__ + "static/media/rose-preview.ea1e7654.svg";